<input
  nz-input
  #input="ngModel"
  [name]="config.name"
  [placeholder]="config.placeholder"
  [(ngModel)]="config.value"
  (ngModelChange)="onChange($event)"
  [required]="config.required"
/>
